import { useEffect } from "react";

import {
  closeModal,
  openModal,
  selectModalIsOpen,
  useBillingQuery,
  useMeQuery,
} from "@chef/state-management";
import { Banner } from "@chef/components";
import { useConfirmDialog } from "@chef/hooks";
import { ACCOUNT_STATUSES, BRAND_PATHS, language } from "@chef/constants";
import { noop } from "@chef/utils/noop";
import { useAppDispatch, useAppSelector } from "@chef/state-management/hooks";

const intl = (
  {
    no: {
      REACTIVATE: "Gjenoppta",
      YOUR_DELIVERIES_ARE_STOPPED: "Dine leveringer er pauset",
    },
    se: {
      REACTIVATE: "Förnya prenumeration",
      YOUR_DELIVERIES_ARE_STOPPED: "Du har pausat din prenumeration",
    },
    dk: {
      REACTIVATE: "Genaktiver",
      YOUR_DELIVERIES_ARE_STOPPED: "Dine leveringer er sat på pause",
    },
  } as const
)[language];

const AccountPausedBanner = () => {
  const dispatch = useAppDispatch();
  const { data: isLoggedIn } = useMeQuery();

  const { data: billingQuery } = useBillingQuery(undefined, {
    skip: !isLoggedIn,
  });

  const onClick = () =>
    dispatch(
      openModal({
        id: "ACCOUNT_REACTIVATION",
        redirectUrl: BRAND_PATHS.POST_REACTIVATION_LOCATION,
      }),
    );

  if (billingQuery?.billing?.status !== ACCOUNT_STATUSES.PAUSED) {
    return null;
  }

  return (
    <Banner onClick={onClick} highlighted>
      <span className="mr-2">{intl.YOUR_DELIVERIES_ARE_STOPPED}</span>
      <span className="underline">
        <strong>{intl.REACTIVATE}</strong>
      </span>
    </Banner>
  );
};

export default AccountPausedBanner;
